import { render, staticRenderFns } from "./WarnPopUp.vue?vue&type=template&id=6e2314ea&scoped=true&"
import script from "./WarnPopUp.vue?vue&type=script&lang=js&"
export * from "./WarnPopUp.vue?vue&type=script&lang=js&"
import style0 from "./WarnPopUp.vue?vue&type=style&index=0&id=6e2314ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2314ea",
  null
  
)

export default component.exports